import React from 'react';
import { ToastManager, TOAST_TYPES } from "../fasades/toastmanager";
import { IoMdCopy } from "react-icons/io";
import './copytext.css';

type Props = {
    text  : string;
    label : string;
};

export class CopyText extends React.Component<Props> 
{
    handleCopy()
    {
        navigator.clipboard.writeText(this.props.text)
            .then(()  => ToastManager.addToast('API key copied to clipboard!', TOAST_TYPES.SUCCESS, 5000))
            .catch(() => ToastManager.addToast('Failed to copy API key',       TOAST_TYPES.ERROR,   3000));
    }

    render() {
        return (
          <>
             <label className="labelStyle" htmlFor="name">{this.props.label}</label>
             <input
                className="inputStyle copyText"
                id="name"
                name="name"
                type="text"
                readOnly={true}
                value={this.props.text}
              />
            <button
                type="button"
                className="buttonStyle copyBtn"
                onClick={() => { this.handleCopy() } }>
                { React.createElement(IoMdCopy as React.ComponentType) }
                Copy
            </button>
          </>
        );
    }
}

